export default __webpack_public_path__ + "static/media/asistencia_viajero-preguntas_frecuentes.d3c1fc98.pdf";